import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitonashikcab() {



    const cardData = {

keyword: "Mumbai Nashik Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai Nashik Cab services for family vacations, business travel, pilgrimage tours, wine tourism, and outstation journeys. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth highway journey. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, flexible travel schedules, 24/7 customer support, and transparent pricing, we ensure a hassle-free and enjoyable trip to Nashik and its nearby attractions.",

topPlaces: [
    {
        title: "Trimbakeshwar Jyotirlinga",
        description:
            "Trimbakeshwar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva and one of the most important pilgrimage destinations in Maharashtra. Situated at the foothills of the Brahmagiri Mountains, the temple is renowned for its unique three-faced lingam representing Brahma, Vishnu, and Mahesh. Devotees visit throughout the year to seek blessings and perform religious rituals while enjoying the serene natural surroundings and spiritual atmosphere."
    },
    {
        title: "Panchavati",
        description:
            "Panchavati is a sacred area in Nashik closely associated with the Ramayana and is believed to be the place where Lord Rama, Sita, and Lakshmana stayed during their exile. The area features important attractions including Kalaram Temple, Sita Gufa, Kapaleshwar Temple, and the holy Godavari ghats. Pilgrims and history enthusiasts alike enjoy exploring its religious significance and cultural heritage."
    },
    {
        title: "Sula Vineyards",
        description:
            "Sula Vineyards is India's most famous wine destination and attracts visitors from across the country for vineyard tours, wine tasting sessions, and scenic countryside views. Guests can explore the grape farms, learn about wine production, and enjoy premium dining experiences. The pleasant surroundings and relaxing atmosphere make it one of Nashik's top tourist attractions."
    },
    {
        title: "Anjaneri Hills",
        description:
            "Anjaneri Hills are believed to be the birthplace of Lord Hanuman and hold immense religious and historical significance. The hill features ancient temples, trekking trails, and panoramic views of the surrounding landscapes. Nature lovers, adventure enthusiasts, and pilgrims visit Anjaneri to enjoy both spiritual experiences and the natural beauty of the Sahyadri ranges."
    },
    {
        title: "Pandavleni Caves",
        description:
            "Pandavleni Caves are a group of ancient Buddhist rock-cut caves dating back over two thousand years. The caves feature intricate carvings, prayer halls, meditation chambers, and inscriptions reflecting India's rich cultural heritage. Located on a hilltop, they also provide beautiful views of Nashik city and surrounding valleys."
    },
    {
        title: "Muktidham Temple",
        description:
            "Muktidham Temple is a beautiful marble temple complex dedicated to various Hindu deities and is one of Nashik's most visited spiritual landmarks. The temple contains replicas of the twelve Jyotirlingas and verses from sacred Hindu scriptures. Its peaceful environment and elegant architecture attract devotees and tourists throughout the year."
    },
    {
        title: "Godavari River Ghats",
        description:
            "The Godavari River Ghats are among the holiest places in Nashik and play a major role during the Kumbh Mela celebrations. Pilgrims gather here to perform rituals, offer prayers, and take holy dips in the sacred river. The ghats are lined with ancient temples and provide a unique spiritual and cultural experience for visitors."
    },
    {
        title: "Harihar Fort",
        description:
            "Harihar Fort is one of Maharashtra's most famous trekking destinations, known for its steep rock-cut steps and breathtaking hilltop views. Adventure enthusiasts enjoy the challenging climb and the rewarding panoramic scenery from the summit. The fort's historical significance and natural beauty make it a popular attraction near Nashik."
    },
    {
        title: "Coin Museum",
        description:
            "The Coin Museum in Nashik is one of the few museums in India dedicated to the history of Indian currency. Visitors can explore ancient coins, historical artifacts, and educational exhibits that showcase the evolution of trade and commerce across different periods of Indian history. It is an interesting stop for families and history lovers."
    },
    {
        title: "Igatpuri",
        description:
            "Igatpuri is a picturesque hill station located on the Mumbai–Nashik route and is famous for its green mountains, waterfalls, lakes, and pleasant climate. Attractions such as Vipassana International Academy, Bhatsa River Valley, and scenic viewpoints make it a perfect stop for relaxation and photography. Many travelers combine Igatpuri with their Mumbai to Nashik cab journey for an even more memorable road trip experience."
    }
],



services: [
{
name: "Mumbai to Nashik Cab",
description: "Mumbai Airport Cab offers Mumbai to Nashik Cab service for comfortable, safe, and affordable intercity travel. Our fleet includes AC Sedan, SUV, Ertiga, Innova Crysta, and premium vehicles for business trips, family travel, pilgrimage tours, and airport transfers. Enjoy doorstep pickup, experienced chauffeurs, flexible travel schedules, one way and round trip options, transparent pricing, and 24x7 booking support for a hassle-free journey."
},
{
name: "Mumbai to Nashik Taxi Fare",
description: "Get the best Mumbai to Nashik Taxi Fare with Mumbai Airport Cab. We offer affordable pricing, fixed fare packages, and comfortable AC vehicles with no hidden charges for one way and round trip travel."
},
{
name: "Mumbai Airport to Nashik Taxi",
description: "Book Mumbai Airport to Nashik Taxi with Mumbai Airport Cab for direct airport transfers. Our drivers monitor flight schedules and provide timely pickup with comfortable vehicles and professional service."
},
{
name: "Mumbai Airport to Nashik Taxi Fare",
description: "Mumbai Airport Cab provides Mumbai Airport to Nashik Taxi Fare with transparent pricing and reliable airport transfer packages suitable for individuals, families, and corporate travelers."
},
{
name: "Mumbai to Deolali Cab",
description: "Book Mumbai to Deolali Cab with Mumbai Airport Cab for safe and convenient travel. Our chauffeur-driven vehicles ensure comfortable transportation for family visits, business travel, and military area transfers."
},
{
name: "Mumbai to Deolali Taxi Fare",
description: "Get affordable Mumbai to Deolali Taxi Fare with Mumbai Airport Cab and enjoy comfortable travel with fixed pricing and professional drivers."
},
{
name: "Mumbai Airport to Nashik Cab",
description: "Mumbai Airport Cab offers Mumbai Airport to Nashik Cab with direct pickup from domestic and international terminals. Enjoy premium vehicles and smooth travel to Nashik city and nearby areas."
},
{
name: "Mumbai to Nashik Taxi Service",
description: "Our Mumbai to Nashik Taxi Service provides reliable transportation with experienced chauffeurs, AC vehicles, and flexible pickup and drop options for all travelers."
},
{
name: "Mumbai Airport to Nashik Taxi Service",
description: "Mumbai Airport Cab provides Mumbai Airport to Nashik Taxi Service for convenient airport connectivity with professional drivers and well-maintained vehicles."
},
{
name: "Mumbai Airport to Nashik Cab Fare",
description: "Check Mumbai Airport to Nashik Cab Fare with Mumbai Airport Cab for budget-friendly and premium travel packages with transparent pricing."
},
{
name: "Mumbai Airport to Nashik Cab Service",
description: "Book Mumbai Airport to Nashik Cab Service with Mumbai Airport Cab for safe airport transfers, comfortable vehicles, and dependable transportation."
},
{
name: "Mumbai to Nashik Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Nashik Cab Booking with instant confirmation, easy reservations, and multiple vehicle choices for every travel need."
},
{
name: "Mumbai to Nashik One Way Cab",
description: "Book Mumbai to Nashik One Way Cab for economical drop-only travel with AC vehicles, experienced chauffeurs, and hassle-free service."
},
{
name: "Mumbai to Nashik Taxi Booking",
description: "Mumbai Airport Cab provides Mumbai to Nashik Taxi Booking with flexible schedules, premium vehicle options, and 24x7 customer support."
},
{
name: "Navi Mumbai to Nashik Cab",
description: "Book Navi Mumbai to Nashik Cab with Mumbai Airport Cab for reliable intercity travel with comfortable seating and professional drivers."
},
{
name: "Navi Mumbai Airport to Nashik Cab",
description: "Mumbai Airport Cab offers Navi Mumbai Airport to Nashik Cab with direct airport pickup and convenient transportation to Nashik and nearby destinations."
},
{
name: "Thane to Nashik Cab",
description: "Book Thane to Nashik Cab with Mumbai Airport Cab for affordable and comfortable travel with AC vehicles and experienced chauffeurs."
},
{
name: "Thane Nashik Taxi Service",
description: "Mumbai Airport Cab provides Thane Nashik Taxi Service for business trips, family travel, and religious tours with safe and dependable transportation."
},
{
name: "Thane to Nashik Cab Service",
description: "Choose Thane to Nashik Cab Service from Mumbai Airport Cab for premium intercity travel with flexible pickup options and professional drivers."
},
{
name: "Thane to Nashik Cab Fare",
description: "Get affordable Thane to Nashik Cab Fare with Mumbai Airport Cab and enjoy transparent pricing and quality service."
},
{
name: "Thane to Nashik Taxi Fare",
description: "Mumbai Airport Cab offers Thane to Nashik Taxi Fare with economical and luxury vehicle options for every type of traveler."
},
{
name: "Mumbai to Nashik Cab Service Near Me",
description: "Find Mumbai to Nashik Cab Service Near Me with Mumbai Airport Cab for quick booking, reliable vehicles, and 24x7 travel assistance."
},
{
name: "Best Cab Service Mumbai to Nashik",
description: "Mumbai Airport Cab provides the Best Cab Service Mumbai to Nashik with premium vehicles, trained chauffeurs, and comfortable long-distance travel."
},
{
name: "Reliable Mumbai Nashik Taxi",
description: "Choose Reliable Mumbai Nashik Taxi from Mumbai Airport Cab for safe journeys, professional service, and affordable travel packages."
},
{
name: "24x7 Mumbai Nashik Cab Service",
description: "Mumbai Airport Cab offers 24x7 Mumbai Nashik Cab Service with round-the-clock availability for airport transfers, business trips, and family travel."
},
{
name: "Instant Mumbai Nashik Cab Booking",
description: "Book Instant Mumbai Nashik Cab Booking with Mumbai Airport Cab for quick confirmation, multiple vehicle options, and hassle-free reservations."
},
{
name: "Mumbai Nashik Taxi Contact Number",
description: "Mumbai Airport Cab provides Mumbai Nashik Taxi Contact Number support for quick inquiries, bookings, travel assistance, and customer service."
},
{
name: "Mumbai Nashik Cab Rental Service",
description: "Book Mumbai Nashik Cab Rental Service with Mumbai Airport Cab for one way, round trip, airport transfers, and customized travel packages."
},
{
name: "Mumbai Nashik Airport Transfer",
description: "Mumbai Airport Cab offers Mumbai Nashik Airport Transfer with punctual pickups, flight tracking, premium vehicles, and comfortable airport connectivity."
},
{
name: "One Way Taxi Mumbai to Nashik",
description: "Book One Way Taxi Mumbai to Nashik with Mumbai Airport Cab for affordable drop-only travel with experienced drivers and clean AC vehicles."
}
],

tableData: [
["Mumbai to Nashik Cab","Mumbai to Nashik Taxi Fare"],
["Mumbai Airport to Nashik Taxi","Mumbai Airport to Nashik Taxi Fare"],
["Mumbai to Deolali Cab","Mumbai to Deolali Taxi Fare"],
["Mumbai Airport to Nashik Cab","Mumbai to Nashik Taxi Service"],
["Mumbai Airport to Nashik Taxi Service","Mumbai Airport to Nashik Cab Fare"],
["Mumbai Airport to Nashik Cab Service","Mumbai to Nashik Cab Booking"],
["Mumbai to Nashik One Way Cab","Mumbai to Nashik Taxi Booking"],
["Navi Mumbai to Nashik Cab","Navi Mumbai Airport to Nashik Cab"],
["Thane to Nashik Cab","Thane Nashik Taxi Service"],
["Thane to Nashik Cab Service","Thane to Nashik Cab Fare"],
["Thane to Nashik Taxi Fare","Mumbai to Nashik Cab Service Near Me"],
["Best Cab Service Mumbai to Nashik","Reliable Mumbai Nashik Taxi"],
["24x7 Mumbai Nashik Cab Service","Instant Mumbai Nashik Cab Booking"],
["Mumbai Nashik Taxi Contact Number","Mumbai Nashik Cab Rental Service"],
["Mumbai Nashik Airport Transfer","One Way Taxi Mumbai to Nashik"]
],




whychoose: [
{
WhyChooseheading: "Reliable Mumbai Nashik Cab Service",
WhyChoosedescription: "Mumbai Airport Cab Service provides dependable Mumbai Nashik Cab transportation for business travelers, families, tourists, pilgrims, and daily commuters seeking a comfortable journey."
},
{
WhyChooseheading: "Convenient Travel Between Mumbai and Nashik",
WhyChoosedescription: "Our cab service offers hassle-free connectivity between Mumbai and Nashik for religious visits, corporate travel, family functions, and leisure trips."
},
{
WhyChooseheading: "Perfect for Corporate and Business Travel",
WhyChoosedescription: "Professionals frequently choose our Mumbai Nashik Cab Service for meetings, industrial visits, conferences, exhibitions, and official transportation requirements."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can select Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel preferences."
},
{
WhyChooseheading: "One-Way and Round Trip Facilities",
WhyChoosedescription: "Whether you require a one-way drop, round-trip booking, same-day return, or customized itinerary, we provide flexible travel options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Thane, Navi Mumbai, Andheri, Borivali, Dadar, Bandra, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Travel Experience",
WhyChoosedescription: "Our experienced drivers and regularly maintained vehicles ensure safe, comfortable, and stress-free travel throughout the journey."
},
{
WhyChooseheading: "Ideal for Pilgrimage and Family Travel",
WhyChoosedescription: "Many travelers book our Mumbai Nashik Cabs for Trimbakeshwar Darshan, religious tours, family visits, vacations, and special occasions."
}
]
};

const faqData = [
{
question: "Why do travelers frequently book Mumbai Nashik Cabs?",
answer: "Nashik is a major religious, industrial, and tourist destination known for Trimbakeshwar Temple, vineyards, business hubs, and pilgrimage tourism."
},
{
question: "Can I book a one-way cab from Mumbai to Nashik?",
answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
},
{
question: "Which vehicle is suitable for Mumbai Nashik travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most popular choices due to their comfort and spacious seating."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return travel depending on their schedule and travel requirements."
},
{
question: "Can business professionals use this service regularly?",
answer: "Yes, many corporate travelers use our Mumbai Nashik Cab Service for official travel, meetings, and industrial visits."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, corporate outings, and group transportation."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Is advance reservation recommended for Mumbai Nashik travel?",
answer: "Yes, advance booking helps secure preferred vehicles and ensures smooth travel planning."
},
{
question: "Can multiple stops be included during the trip?",
answer: "Yes, customers can customize their journey by adding Trimbakeshwar Temple, vineyards, business locations, or personal stops."
},
{
question: "How can I book a Mumbai Nashik Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Amit Deshpande",
feedback:
"I frequently travel between Mumbai and Nashik for business purposes, and Mumbai Airport Cab Service consistently provides punctual pickups, comfortable vehicles, and professional drivers.",
rating: 5
},
{
id: 2,
name: "Mrs. Kavita Kulkarni",
feedback:
"We booked a Mumbai Nashik Cab for a family trip and Trimbakeshwar Darshan. The vehicle was clean, spacious, and the entire journey was smooth and enjoyable.",
rating: 5
}
];


























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai Nashik Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-nashik-cab.jpg",
"description": "Book Mumbai Nashik cab service for comfortable and affordable travel. Mumbai Airport Cabs offers reliable taxi service from Mumbai and Mumbai Airport to Nashik and Deolali with professional drivers, clean vehicles, transparent pricing, and 24/7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-nashik-cab"
}
};







    return (
        <div>



<Helmet>
  <title>Mumbai Nashik Cab | Mumbai Airport to Nashik Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai Nashik cab service and Mumbai Airport to Nashik taxi at affordable fares. Safe, reliable, and comfortable taxi service with professional drivers for Nashik and Deolali travel."
/>

<meta
 name="keywords"
 content="mumbai nashik cab, mumbai to nasik taxi fare, mumbai airport to nasik taxi, mumbai airport to nasik taxi fare, mumbai to deolali cab, mumbai to deolali taxi fare, mumbai airport to nashik cab, mumbai to nashik taxi service, mumbai airport to nashik taxi, mumbai airport to nashik taxi fare, mumbai airport to nashik taxi service, one way cab mumbai to nashik, round trip taxi mumbai to nashik, nashik cab booking from mumbai, car rental mumbai to nashik"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/110.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitonashikcab;